import { callApi } from '../common/services/baseServices';
import { getCookie } from '../common/enum/index';
import { host } from '../environment';

const ACTIONS_NOTIFICATION = {
    GET_NOTIFICATION_SUCCESS: 'GET_NOTIFICATION_SUCCESS',
    GET_NOTIFICATION_ERROR: 'GET_NOTIFICATION_ERROR',
    GET_NOTICE_LATEST_SUCCESS: 'GET_NOTICE_LATEST_SUCCESS',
    GET_NOTICE_LATEST_ERROR: 'GET_NOTICE_LATEST_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const getNotification = () => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    let url = `${host.serverTest}api/notifications/count`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                if (data.error) {
                    dispatch(updateStatus(ACTIONS_NOTIFICATION.GET_NOTIFICATION_ERROR, data));
                } else {
                    dispatch(updateStatus(ACTIONS_NOTIFICATION.GET_NOTIFICATION_SUCCESS, data));
                }
            },
            (err) => {
                dispatch(updateStatus(ACTIONS_NOTIFICATION.GET_NOTIFICATION_ERROR, err));
            });
    };
};

const getNoticesLatest = () => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    let url = `${host.serverTest}api/notices/latest`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                if (data.error) {
                    dispatch(updateStatus(ACTIONS_NOTIFICATION.GET_NOTICE_LATEST_ERROR, data));
                } else {
                    dispatch(updateStatus(ACTIONS_NOTIFICATION.GET_NOTICE_LATEST_SUCCESS, data));
                }
            },
            (err) => {
                dispatch(updateStatus(ACTIONS_NOTIFICATION.GET_NOTICE_LATEST_ERROR, err));
            });
    };
};

export {
    ACTIONS_NOTIFICATION, getNotification, getNoticesLatest
};